// 10級パッケージの6級
type ckptTypeForGrade_14_20kyu =
  | 'よい姿勢'
  | '足を体の前で回す'
  | '足のつき方'
  | 'スピードを出す';

export const ckptForGrade_14_20kyu: ckptTypeForGrade_14_20kyu[] = [
  'よい姿勢',
  '足を体の前で回す',
  '足のつき方',
  'スピードを出す',
];

export const requirement_14_20kyu: ckptTypeForGrade_14_20kyu[] = [
  'よい姿勢',
  '足を体の前で回す',
];
